<template>
  <component
    :is="basket ? 'router-link' : 'span'"
    :to="{
      name: isAdmin ? 'adminOrderBasketView' : 'orderBasketStep',
      params: { basketId }
    }"
    :class="[
      'is-flex',
      'is-size-7',
      'has-items-aligned-center',
      'has-text-brand-contrast'
    ]"
  >
    <b-icon icon="shopping-basket" />
    <span class="has-margin-left-25">
      <strong>{{ $_.get(basket, "products", []).length }}</strong>
      <span class="is-hidden-mobile">{{
        $tc("_.item", $_.get(basket, "products", []).length).toLowerCase()
      }}</span>
    </span>
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Context from "@/mixins/context";
import type { PropType } from "vue";
import type { IBasketProviderData } from "@/models/providers/baskets";
import type { IShopProviderData } from "@/models/providers/shop";

export default defineComponent({
  name: "BasketButton",
  mixins: [Context],
  inject: {
    $basketData: {
      from: "basketProviderData",
      type: Function as PropType<IBasketProviderData>
    },
    $shopProviderData: {
      from: "shopProviderData",
      type: Function as PropType<IShopProviderData>
    }
  },
  computed: {
    basket() {
      return this.$basketData().basket;
    },
    basketId() {
      return this.$basketData().basketId;
    }
  }
});
</script>
